"use strict";
// The B/L number is locked once the revamp owns the edit path.
//
// The number is the shipment's identity: the invoice chain keys on it and carrier
// tracking is requested against it. A free-text edit moves all three at once and
// tells nobody, so replacing the document becomes the only path that changes it —
// heavier on purpose.
//
// Shared because three surfaces must agree on it. Two write paths refuse the
// field server-side, and the forms disable their input with the same sentence.
// An operator who reads one explanation in the field and a different one in the
// error learns that the two are separate rules, which they are not.
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOCKED_BL_NUMBER_MESSAGE = exports.LOCKED_BL_NUMBER_FIELD = void 0;
/** The payload key both write paths refuse. */
exports.LOCKED_BL_NUMBER_FIELD = 'bl_number';
/**
 * Why the field is shut, and which path does work.
 *
 * The write paths answer 422 with this rather than a strict-mode 400 about an
 * unrecognised key: an operator who types in the field deserves to be told where
 * the number can be changed.
 */
exports.LOCKED_BL_NUMBER_MESSAGE = 'The BL number cannot be edited directly. Replace the bill of lading document to change it — ' +
    'live tracking and the invoice chain key on this number.';
//# sourceMappingURL=locked-bl-number.js.map